import React from "react";
import styles from "@components/MarketVisitReport/MarketVisitReport.module.css";

/**
 * MiscellaneousSection Component
 * Large improvement areas and miscellaneous observations section
 * 
 * @param {Object} formData - Form data
 * @param {Function} onChange - Handler for form field changes
 * @param {Object} characterLimitValidation - Character limit validation errors
 * @param {Object} formValidation - Form validation errors
 * @param {Boolean} disable - Form disable state
 */
const MiscellaneousSection = ({
  formData,
  onChange,
  characterLimitValidation,
  formValidation,
  disable,
}) => {
  return (
    <>
      {/* Large Improvement Areas */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Large Improvement Areas: Suggestions which might require creation of a
          new policy or change in existing ones
        </label>
        <textarea
          name="largeImproveAreas"
          value={formData?.largeImproveAreas}
          rows="3"
          className={` ${styles.MarketVisitRepor__textArea}`}
          style={{ paddingLeft: "8px" }}
          onChange={(e) => onChange(e)}
          disabled={disable}
          maxLength={501}
        />
        {characterLimitValidation?.largeImproveAreas && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.largeImproveAreas}
          </p>
        )}
        {!formData?.largeImproveAreas && formValidation?.largeImproveAreas && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {formValidation?.largeImproveAreas}
          </p>
        )}
      </div>

      {/* Miscellaneous Section Header */}
      <div className={`row m-0 ${styles.MarketVisitReport__headingBox}`}>
        <div className={`col-12 p-0 ${styles.MarketVisitReport__heading}`}>
          Miscellaneous Section
        </div>
      </div>

      {/* Miscellaneous Observations */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Observations not falling under any of the above sections
        </label>
        <textarea
          name="miscellaneousSection"
          value={formData?.miscellaneousSection}
          rows="3"
          className={` ${styles.MarketVisitRepor__textArea}`}
          style={{ paddingLeft: "8px" }}
          onChange={(e) => onChange(e)}
          disabled={disable}
          maxLength={501}
        />
        {characterLimitValidation?.miscellaneousSection && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.miscellaneousSection}
          </p>
        )}
        {!formData?.miscellaneousSection &&
          formValidation?.miscellaneousSection && (
            <p className={styles.MarketVisitReport__validationErrors}>
              {formValidation?.miscellaneousSection}
            </p>
          )}
      </div>
    </>
  );
};

export default MiscellaneousSection;
